module.exports = __webpack_public_path__ + "static/media/read.ebf2e532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read.png
// module id = 605
// module chunks = 0